const { currentProject } = require("../../../project.config.js");
const projectInfo = require(`./${currentProject}.js`);

export {
    currentProject,
    projectInfo
};
